module.exports = __webpack_public_path__ + "res/0_ic_congratulations.3c0b03edd47a89ad487b1eea68d9e712.png";